import { useTranslation } from "react-i18next";
import { deleteFlowMutation, listFlowsQueryKey } from "@/api";
import { useDeleteEntity } from "@/components/build/useDeleteEntity";

/** Delete-with-confirm for a workflow (accepts a summary or full response). */
export function useDeleteFlow(onDeleted?: () => void) {
  const { t } = useTranslation("workflows");
  return useDeleteEntity<{ uuid: string; name: string }>({
    mutation: deleteFlowMutation(),
    listQueryKey: listFlowsQueryKey,
    pathFor: (f) => ({ flow_uuid: f.uuid }),
    messages: { deleted: t("deleted"), deleteFailed: t("deleteFailed") },
    onDeleted,
  });
}
